var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7H0L0 9H1L1 7ZM30.5943 8.70711C30.9848 8.31658 30.9848 7.68342 30.5943 7.29289L24.2303 0.928932C23.8398 0.538408 23.2066 0.538408 22.8161 0.928932C22.4256 1.31946 22.4256 1.95262 22.8161 2.34315L28.4729 8L22.8161 13.6569C22.4256 14.0474 22.4256 14.6805 22.8161 15.0711C23.2066 15.4616 23.8398 15.4616 24.2303 15.0711L30.5943 8.70711ZM1 9L29.8872 9V7L1 7L1 9Z",
    fill: "#C7F700"
  })));
};
export default SvgArrow;